
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ricerca",
      function () {
        return require("private-next-pages/ricerca/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ricerca"])
      });
    }
  